import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { WinMarketsCount } from '../../components/statistics/winMarketsCount';
import StatisticList from '../../components/statistics/statisticList';
import { roundsWinBetTypes } from '../../store/roundsWinBetTypes';
import StatisticListWr from '../../components/statistics/statisticListWr';
// import ChangeStatisticType from '../../components/statistics/changeStatisticType';

export const Statistics = observer(({ isReplay }) => {
  const { winBetTypes } = roundsWinBetTypes;
  // eslint-disable-next-line
  const [statisticType, setStatisticType] = useState(null);

  return (
    <div className='bottom-right-column'>
      <div className='bottom-right-column-inner'>
        <div className='bottom-right-column-inner-sheet'>
          <StatisticListWr
            isReplay={isReplay}
            statisticType={statisticType}
            winBetTypes={winBetTypes}
            WinMarketsComp={WinMarketsCount}
            StatisticListComp={StatisticList}
          />
        </div>
        {/* <ChangeStatisticType setStatisticType={setStatisticType} /> */}
      </div>
    </div>
  );
});
